<template>
    <div v-if="friendRef">
        <Modal :confirmLabel="false" :cancelLabel="$t('modules.friends.friendsHelpModal.closeModal')"
            @onConfirm="onConfirm"
            @onClose="onClose"
            :isOpen="isOpen"
            :modalTitle="modalTitle" >
            <span v-html="$t('modules.friends.friendsHelpModal.notice', {recruiter_name: friendRef.recruiter_name})"></span>
        </Modal>
    </div>
</template>

<script>
export default {
    name: 'FriendHelpModal',
    components: {},
    data(){
        return {
            isOpen: false
        }
    },
    mounted(){
        setTimeout(() => {
            if(!this.friendRef.completed){ this.isOpen = true }
        }, 300)
    },
    computed: {
        friendRef(){
            return this.$store.state.FriendStore.friendRef
        },
        modalTitle(){
            return this.$i18n.t('modules.friends.friendsHelpModal.welcome') + " " + this.friendRef.friend_username
        }
    },
    methods: {
        onConfirm(){

        },
        onClose(){
            this.isOpen = false
        }
    }
}

</script>

<style lang="scss">

</style>